import React from 'react';
import PropTypes from 'prop-types';
import { useRouter } from 'next/router';
import { useSelector } from 'react-redux';
import getCurrentPaging from '@src/containers/Session/selectors/getCurrentPaging';
import Paging from '..';

const PagingCDefault = ({ isShallow, totalPages, totalQtty }) => {
	const { page, perPage } = useSelector(getCurrentPaging);
	const router = useRouter();

	if (totalPages > 1) {
		const description = totalQtty
			? `${t('Показано {pages}', {
					total: totalQtty,
					pages: `${Math.max(perPage * (page - 1), 1)}–${Math.min(
						page * perPage,
						totalQtty,
					)}`,
			  })} ${t(
					'из {n} пространствa|из {n} пространств|из {n} пространств',
					totalQtty,
			  )}`
			: null;

		return (
			<Paging
				isShallow={isShallow}
				currentPage={page}
				totalPages={totalPages}
				baseHref={router.asPath}
				description={description}
			/>
		);
	}

	return null;
};

PagingCDefault.propTypes = {
	isShallow: PropTypes.bool,
	totalPages: PropTypes.number,
	totalQtty: PropTypes.number,
};

PagingCDefault.defaultProps = {
	isShallow: false,
	totalPages: undefined,
	totalQtty: undefined,
};

export default PagingCDefault;
